/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Extract_LabelInputs */



/**
* | output |
* | --- |
* | "Extract Subtitles" |
*
* @param {File_Import_Extract_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_extract_label = /** @type {((inputs?: File_Import_Extract_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Extract_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraire les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitel extrahieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrai i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечь субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extraer subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提取字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕を抽出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक निकालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extrair legendas")
	return /** @type {LocalizedString} */ ("Extract Subtitles")
});